import { render } from "./orders.vue?vue&type=template&id=12951e7e"
import script from "./orders.vue?vue&type=script&lang=js"
export * from "./orders.vue?vue&type=script&lang=js"

import "./orders.vue?vue&type=style&index=0&id=12951e7e&lang=css"
script.render = render

export default script